export const COLLECTION_LEAD = "lead";
export const COLLECION_USER = "user";
export const COLLECTION_SESSION = "session";
export const COLLECTION_AFFILIATE = "affiliate";
